module.exports = __webpack_public_path__ + "static/media/Zigzagoon_gaussian2.99d4f449.png";